export default __webpack_public_path__ + "graphics/eye.131e7c99.svg";